export var HdsIconlibraryData_24px;
(function (HdsIconlibraryData_24px) {
    HdsIconlibraryData_24px["AppOutline_24px"] = "app_outline_24px";
    HdsIconlibraryData_24px["AppSolid_24px"] = "app_solid_24px";
    HdsIconlibraryData_24px["BranchOutline_24px"] = "branch_outline_24px";
    HdsIconlibraryData_24px["BranchSolid_24px"] = "branch_solid_24px";
    HdsIconlibraryData_24px["CatalogOutline_24px"] = "catalog_outline_24px";
    HdsIconlibraryData_24px["CatalogSolid_24px"] = "catalog_solid_24px";
    HdsIconlibraryData_24px["ConflateOutline_24px"] = "conflate_outline_24px";
    HdsIconlibraryData_24px["ConflateSolid_24px"] = "conflate_solid_24px";
    HdsIconlibraryData_24px["DatabaseOutline_24px"] = "database_outline_24px";
    HdsIconlibraryData_24px["DatabaseSolid_24px"] = "database_solid_24px";
    HdsIconlibraryData_24px["DeployOutline_24px"] = "deploy_outline_24px";
    HdsIconlibraryData_24px["DeploySolid_24px"] = "deploy_solid_24px";
    HdsIconlibraryData_24px["ExportOutline_24px"] = "export_outline_24px";
    HdsIconlibraryData_24px["ExportSolid_24px"] = "export_solid_24px";
    HdsIconlibraryData_24px["IndexOutline_24px"] = "index_outline_24px";
    HdsIconlibraryData_24px["IndexSolid_24px"] = "index_solid_24px";
    HdsIconlibraryData_24px["InspectOutline_24px"] = "inspect_outline_24px";
    HdsIconlibraryData_24px["InspectSolid_24px"] = "inspect_solid_24px";
    HdsIconlibraryData_24px["InteractiveOutline_24px"] = "interactive_outline_24px";
    HdsIconlibraryData_24px["InteractiveSolid_24px"] = "interactive_solid_24px";
    HdsIconlibraryData_24px["LayersOutline_24px"] = "layers_outline_24px";
    HdsIconlibraryData_24px["LayersSolid_24px"] = "layers_solid_24px";
    HdsIconlibraryData_24px["MarketplaceOutline_24px"] = "marketplace_outline_24px";
    HdsIconlibraryData_24px["MarketplaceSolid_24px"] = "marketplace_solid_24px";
    HdsIconlibraryData_24px["MergeAltOutline_24px"] = "merge-alt_outline_24px";
    HdsIconlibraryData_24px["MergeAltSolid_24px"] = "merge-alt_solid_24px";
    HdsIconlibraryData_24px["PipelineOutline_24px"] = "pipeline_outline_24px";
    HdsIconlibraryData_24px["PipelineSolid_24px"] = "pipeline_solid_24px";
    HdsIconlibraryData_24px["RebaseOutline_24px"] = "rebase_outline_24px";
    HdsIconlibraryData_24px["RebaseSolid_24px"] = "rebase_solid_24px";
    HdsIconlibraryData_24px["RestOutline_24px"] = "rest_outline_24px";
    HdsIconlibraryData_24px["RestSolid_24px"] = "rest_solid_24px";
    HdsIconlibraryData_24px["ReviewOutline_24px"] = "review_outline_24px";
    HdsIconlibraryData_24px["ReviewSolid_24px"] = "review_solid_24px";
    HdsIconlibraryData_24px["SendToListOutline_24px"] = "send-to-list_outline_24px";
    HdsIconlibraryData_24px["SendToListSolid_24px"] = "send-to-list_solid_24px";
    HdsIconlibraryData_24px["ServicesOutline_24px"] = "services_outline_24px";
    HdsIconlibraryData_24px["ServicesSolid_24px"] = "services_solid_24px";
    HdsIconlibraryData_24px["StreamOutline_24px"] = "stream_outline_24px";
    HdsIconlibraryData_24px["StreamSolid_24px"] = "stream_solid_24px";
    HdsIconlibraryData_24px["TemplateOutline_24px"] = "template_outline_24px";
    HdsIconlibraryData_24px["TemplateSolid_24px"] = "template_solid_24px";
    HdsIconlibraryData_24px["UpdateBaseMapOutline_24px"] = "update-base-map_outline_24px";
    HdsIconlibraryData_24px["UpdateBaseMapSolid_24px"] = "update-base-map_solid_24px";
    HdsIconlibraryData_24px["VersionedOutline_24px"] = "versioned_outline_24px";
    HdsIconlibraryData_24px["VersionedSolid_24px"] = "versioned_solid_24px";
    HdsIconlibraryData_24px["VolatileOutline_24px"] = "volatile_outline_24px";
    HdsIconlibraryData_24px["VolatileSolid_24px"] = "volatile_solid_24px";
})(HdsIconlibraryData_24px = HdsIconlibraryData_24px || (HdsIconlibraryData_24px = {}));
export const HDS_ICONLIBRARY_DATA_24PX_CODEPOINTS = {
    [HdsIconlibraryData_24px.AppOutline_24px]: '61697',
    [HdsIconlibraryData_24px.AppSolid_24px]: '61698',
    [HdsIconlibraryData_24px.BranchOutline_24px]: '61699',
    [HdsIconlibraryData_24px.BranchSolid_24px]: '61700',
    [HdsIconlibraryData_24px.CatalogOutline_24px]: '61701',
    [HdsIconlibraryData_24px.CatalogSolid_24px]: '61702',
    [HdsIconlibraryData_24px.ConflateOutline_24px]: '61703',
    [HdsIconlibraryData_24px.ConflateSolid_24px]: '61704',
    [HdsIconlibraryData_24px.DatabaseOutline_24px]: '61705',
    [HdsIconlibraryData_24px.DatabaseSolid_24px]: '61706',
    [HdsIconlibraryData_24px.DeployOutline_24px]: '61707',
    [HdsIconlibraryData_24px.DeploySolid_24px]: '61708',
    [HdsIconlibraryData_24px.ExportOutline_24px]: '61709',
    [HdsIconlibraryData_24px.ExportSolid_24px]: '61710',
    [HdsIconlibraryData_24px.IndexOutline_24px]: '61711',
    [HdsIconlibraryData_24px.IndexSolid_24px]: '61712',
    [HdsIconlibraryData_24px.InspectOutline_24px]: '61713',
    [HdsIconlibraryData_24px.InspectSolid_24px]: '61714',
    [HdsIconlibraryData_24px.InteractiveOutline_24px]: '61715',
    [HdsIconlibraryData_24px.InteractiveSolid_24px]: '61716',
    [HdsIconlibraryData_24px.LayersOutline_24px]: '61717',
    [HdsIconlibraryData_24px.LayersSolid_24px]: '61718',
    [HdsIconlibraryData_24px.MarketplaceOutline_24px]: '61719',
    [HdsIconlibraryData_24px.MarketplaceSolid_24px]: '61720',
    [HdsIconlibraryData_24px.MergeAltOutline_24px]: '61721',
    [HdsIconlibraryData_24px.MergeAltSolid_24px]: '61722',
    [HdsIconlibraryData_24px.PipelineOutline_24px]: '61723',
    [HdsIconlibraryData_24px.PipelineSolid_24px]: '61724',
    [HdsIconlibraryData_24px.RebaseOutline_24px]: '61725',
    [HdsIconlibraryData_24px.RebaseSolid_24px]: '61726',
    [HdsIconlibraryData_24px.RestOutline_24px]: '61727',
    [HdsIconlibraryData_24px.RestSolid_24px]: '61728',
    [HdsIconlibraryData_24px.ReviewOutline_24px]: '61729',
    [HdsIconlibraryData_24px.ReviewSolid_24px]: '61730',
    [HdsIconlibraryData_24px.SendToListOutline_24px]: '61731',
    [HdsIconlibraryData_24px.SendToListSolid_24px]: '61732',
    [HdsIconlibraryData_24px.ServicesOutline_24px]: '61733',
    [HdsIconlibraryData_24px.ServicesSolid_24px]: '61734',
    [HdsIconlibraryData_24px.StreamOutline_24px]: '61735',
    [HdsIconlibraryData_24px.StreamSolid_24px]: '61736',
    [HdsIconlibraryData_24px.TemplateOutline_24px]: '61737',
    [HdsIconlibraryData_24px.TemplateSolid_24px]: '61738',
    [HdsIconlibraryData_24px.UpdateBaseMapOutline_24px]: '61739',
    [HdsIconlibraryData_24px.UpdateBaseMapSolid_24px]: '61740',
    [HdsIconlibraryData_24px.VersionedOutline_24px]: '61741',
    [HdsIconlibraryData_24px.VersionedSolid_24px]: '61742',
    [HdsIconlibraryData_24px.VolatileOutline_24px]: '61743',
    [HdsIconlibraryData_24px.VolatileSolid_24px]: '61744',
};
//# sourceMappingURL=hds-iconlibrary-data-24px.js.map